/* app/js/src/components/media-transcoder/jobs/history/transcoding-job-report/transcoding-job-report.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  position: fixed;
  z-index: 22;
}
.container {
  position: absolute;
  transition: opacity ease-in 0.2s;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  transform: translate(32%, 50%);
  background-color: white;
}
.container .header {
  cursor: move;
  background-color: #141b22;
  color: white;
  height: 6%;
  padding-left: 2vw;
  padding-right: 2vw;
}
.container .header .window-buttons {
  margin-top: 0.4vw;
}
.container .header h2 {
  margin: 0;
  padding: 0.4vw;
}
.container .body {
  height: 74%;
  background-color: white;
}
.container .report-loading {
  align-items: center;
  min-height: 8rem;
  padding: 2rem;
}
.container .report-loading-message {
  margin: 0;
  color: #6c757d;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-align: center;
}
.report-table {
  margin: 1vw;
  text-align: center;
  color: #232f3a;
}
.report-table tr {
  cursor: pointer;
}
.report-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.report-table tbody tr:hover {
  background-color: #e7dfdf;
}
.report-table th {
  border-bottom: 1px solid #232f3a;
}
.report-table th,
.report-table td {
  height: 2vw;
  white-space: nowrap;
  padding: 1vw;
}
/*# sourceMappingURL=transcoding-job-report.component.css.map */
